import swal from 'sweetalert';
import { baseApiAxios, showError } from '../../../js/portal/api';
import { addToast, checkValueAgainstList, InfoTable, InfoTableWide } from '../../../js/portal/main';
import { addSpinner, removeSpinners } from '../../../js/portal/sidebar';
import { DetailsTabLayout, TabPane, DetailSection } from './DetailsTabLayout';

async function deleteDxGwHandler(network_information) {
  swal({
    title: 'Are you sure?',
    text: 'Are you sure you want to delete "' + network_information.name + '" from the database?',
    icon: 'warning',
    buttons: {
      cancel: {
        text: 'Cancel',
        value: null,
        visible: true,
      },
      reset: {
        text: 'Delete',
        value: true,
        className: 'swal-button swal-button--confirm swal-button--danger',
      },
    },
    dangerMode: true,
  }).then(async response => {
    if (response) {
      addSpinner();
      let api_result;
      try {
        api_result = await baseApiAxios.deleteNetworkItem(network_information.id, network_information.uuid);
        window.location.hash = '#listdxgw';
        addToast('Delete DXGW', api_result.message, 6000);
      } catch (err) {
        removeSpinners();
        showError(err);
      }
    }
  });
}

export default function DXGWTabs(props) {
  const { data } = props;

  if (!data.network_item) data.network_item = {};
  if (!data.account_item) data.account_item = {};

  const { account_item, network_item } = data;

  // Direct Connect Gateway
  const permissions = localStorage.permissions ? localStorage.permissions : false;
  const network_data = {
    item_type: network_item.item_type,
    uuid: network_item.uuid,
    id: network_item.id,
    name: network_item.name,
  };

  // Associations
  const assoc_items = [];
  network_item.dx_associations?.forEach(item => {
    const cidrs = [];
    item.allowedPrefixesToDirectConnectGateway.forEach(prefix => {
      cidrs.push(prefix.cidr);
    });

    const assoc_item = {
      AssociationId: item.associationId,
      AssociationState: item.associationState,
      DirectConnectGatewayId: item.directConnectGatewayId,
      DirectConnectGatewayOwnerAccount: item.directConnectGatewayOwnerAccount,
      VirtualGatewayId: item.virtualGatewayId,
      VirtualGatewayOwnerAccount: item.virtualGatewayOwnerAccount,
      VirtualGatewayRegion: item.virtualGatewayRegion,
      CIDRs: cidrs.join(', '),
    };

    assoc_items.push(assoc_item);
  });
  const associationsEnabled = !!assoc_items.length;

  // Interfaces
  const interfacesEnabled = !!network_item.dx_virtual_interfaces?.length;

  const dxGwId = network_item.dx_gw_id;

  const tabs = [
    { id: 'dx_gw' + dxGwId, label: 'Direct Connect Gateway' },
    { id: 'associations' + dxGwId, label: 'Associations', disabled: !associationsEnabled },
    { id: 'interfaces' + dxGwId, label: 'Virtual Interfaces', disabled: !interfacesEnabled },
  ];

  return (
    <DetailsTabLayout tabs={tabs}>
      <TabPane id={'dx_gw' + dxGwId} active name="dx-gw-container">
        <div class="col-md-12 col-lg-6">
          <DetailSection title="Direct Connect Gateway Details">
            <InfoTable
              data={network_item}
              rowInfos={[
                { Name: 'Account Id', Value: 'aws_account_id' },
                { Name: 'DX Gateway ID', Value: 'dx_gw_id' },
                { Name: 'Name', Value: 'name' },
                { Name: 'Region', Value: 'aws_region' },
                { Name: 'Transfer Network Peering', Value: 'netbond_cidr' },
                { Name: 'DX Gateway Status', Value: 'status' },
                { Name: 'Error Details', Value: 'error_details' },
                { Name: 'Last Status Update (UTC)', Value: 'status_update' },
              ]}
            />
          </DetailSection>
          {checkValueAgainstList('manage_networks', permissions) && (
            <div class="detailsContent">
              <div class="btn-group detail-actions-button-group">
                <button class="btn-sm" onclick={() => deleteDxGwHandler(network_data)}>
                  <span class="fas fa-trash-alt" /> Delete
                </button>
              </div>
            </div>
          )}
        </div>
        <div class="col-md-12 col-lg-6">
          <DetailSection title="Account Details">
            <InfoTable
              data={account_item}
              rowInfos={[
                { Name: 'Account Id', Value: 'account_id' },
                { Name: 'Root Account', Value: 'account_root_email' },
                { Name: 'Friendly Name', Value: 'account_friendly_name' },
                { Name: 'Description', Value: 'description' },
                { Name: 'FPC Status', Value: 'fpc_status' },
                { Name: 'Account Area', Value: 'account_area' },
                { Name: 'Account Type', Value: 'account_type' },
                { Name: 'Account Stage', Value: 'account_stage' },
                { Name: 'AWS Support Plan', Value: 'support_plan' },
                { Name: 'IT Responsible', Value: 'it_responsible' },
                { Name: 'Business Service ID', Value: 'cost_data.business_service_id' },
                { Name: 'Application Service ID', Value: 'cost_data.application_service_id' },
                { Name: 'Cost Center', Value: 'cost_data.cost_center' },
                { Name: 'WBS', Value: 'WBS' },
                { Name: 'Creation Date', Value: 'creation_date' },
              ]}
            />
          </DetailSection>
        </div>
      </TabPane>
      <TabPane id={'associations' + dxGwId} name="associations-container">
        {associationsEnabled && (
          <div class="col-md-12 col-md-12">
            <DetailSection title="Direct Connect Gateway Associations">
              <InfoTableWide
                data={assoc_items}
                colInfos={[
                  'VirtualGatewayOwnerAccount',
                  'VirtualGatewayId',
                  'VirtualGatewayRegion',
                  'CIDRs',
                  'AssociationId',
                  'AssociationState',
                  'DirectConnectGatewayId',
                  'DirectConnectGatewayOwnerAccount',
                ]}
                rowNumbers={true}
              />
            </DetailSection>
          </div>
        )}
      </TabPane>
      <TabPane id={'interfaces' + dxGwId} name="interfaces-container">
        {interfacesEnabled && (
          <div class="col-lg-12 col-md-12">
            <DetailSection title="Direct Connect Interfaces">
              <InfoTableWide
                data={network_item.dx_virtual_interfaces}
                colInfos={[
                  'region',
                  'addressFamily',
                  'virtualGatewayId',
                  'virtualInterfaceId',
                  'virtualInterfaceName',
                  'virtualInterfaceState',
                  'virtualInterfaceType',
                  'amazonAddress',
                  'amazonSideAsn',
                  'customerAddress',
                  'asn',
                  'vlan',
                  'directConnectGatewayId',
                ]}
              />
            </DetailSection>
          </div>
        )}
      </TabPane>
    </DetailsTabLayout>
  );
}
